import React from 'react';
import { UserNavbar, Layout } from '../../../components';
import AboutSection from '../../homepage/components/SectionAbout';

function AboutUs() {
  return (
    <Layout>
      <UserNavbar />
      <AboutSection />
    </Layout>
  );
}

AboutUs.propTypes = {};

export default AboutUs;
